import { addUniqueId, getDataCopy, readExcelFile } from "../../App";
import React, { useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Table } from "../table/Table";
import {
  ClearedPaymentRegisterTableHeaders,
  MatchingBSHeadersInPR,
  PaymentRegisterHeaders,
  PaymentRegisterTableHeaders,
} from "./paymentsContants";
import {
  downloadPaymentOutput,
  handleGLFileSelection,
  handleMatchReportFileSelection,
  matchDisbursements,
} from "./paymentUtils";
import {
  BankPaymentStatementItem,
  MatchedPaymentRegisterItemWithBankDetails,
  PaymentRegisterItem,
  PaymentsOutput,
} from "./types";

function Payments(props: {
  onDisbursementBankStatementFileChange?: (
    bankStatementData: BankPaymentStatementItem[]
  ) => void;
  onDisbursementPaymentRegisterFileChange?: (
    paymentRegisterData: PaymentRegisterItem[]
  ) => void;
}) {
  async function handleDisbursementBankStatementFileSelection(
    fileChangeEvent: React.ChangeEvent<HTMLInputElement>
  ) {
    if (
      fileChangeEvent.target.files &&
      fileChangeEvent.target.files.length > 0
    ) {
      const bankStatements = (await readExcelFile(fileChangeEvent)) || [];
      const bankStatementsWithUniqueId: BankPaymentStatementItem[] =
        addUniqueId(bankStatements) as BankPaymentStatementItem[];
      const bankStatementsMasterDataWithUniqueId: BankPaymentStatementItem[] =
        getDataCopy<BankPaymentStatementItem>(bankStatementsWithUniqueId);
      setBankStatementData(bankStatementsMasterDataWithUniqueId);
    }
  }

  async function handlePaymentRegisterFileSelection(
    fileChangeEvent: React.ChangeEvent<HTMLInputElement>
  ) {
    const paymentRegisters = (await readExcelFile(fileChangeEvent)) || [];
    const paymentRegistersWithUniqueId: PaymentRegisterItem[] = addUniqueId(
      paymentRegisters
    ) as PaymentRegisterItem[];
    const paymentRegistersMasterDataWithUniqueId: PaymentRegisterItem[] =
      getDataCopy<PaymentRegisterItem>(paymentRegistersWithUniqueId);
    setPaymentRegisterData(paymentRegistersMasterDataWithUniqueId);
  }

  const [bankStatementData, setBankStatementData] =
    useState<BankPaymentStatementItem[]>();
  const [paymentRegisterData, setPaymentRegisterData] =
    useState<PaymentRegisterItem[]>();
  const [matchedPayments, setMatchedPayments] =
    useState<MatchedPaymentRegisterItemWithBankDetails[]>();
  const [paymentsOutput, setPaymentsOutput] = useState<PaymentsOutput>();
  return (
    <section>
      <section>
        <div className="fileContainer">
          <label>Upload DISB bank statement</label>
          <input
            type={"file"}
            onChange={handleDisbursementBankStatementFileSelection}
          />
        </div>
        <div className="fileContainer">
          <label>Upload Payment register</label>
          <input type={"file"} onChange={handlePaymentRegisterFileSelection} />
        </div>

        <div className="fileContainer">
          <label>Upload GL</label>
          <input type={"file"} onChange={handleGLFileSelection} />
        </div>
        <div className="fileContainer">
          <label>Upload Match report</label>
          <input type={"file"} onChange={handleMatchReportFileSelection} />
        </div>
      </section>
      <section className="fileContainer">
        <button
          onClick={() => {
            if (bankStatementData && paymentRegisterData) {
              const paymentOutputs = matchDisbursements(
                paymentRegisterData,
                bankStatementData
              );
              setPaymentsOutput(paymentOutputs);
            }
          }}
        >
          Match Payments
        </button>
      </section>
      <section>
        {paymentsOutput && (
          <section>
            <section className="fileContainer">
              <button
                onClick={() => {
                  downloadPaymentOutput(paymentsOutput);
                }}
              >
                Download Reports
              </button>
            </section>
            <Tabs>
              <TabList>
                <Tab>Outstanding Payments </Tab>
                <Tab>Cleared Payments </Tab>
              </TabList>
              <TabPanel>
                <section className="table-container">
                  <h2
                    style={{
                      marginBottom: "25px",
                    }}
                  >
                    Outstanding Payments
                  </h2>
                  <Table<PaymentRegisterItem>
                    data={paymentsOutput.outstandingPRs}
                    tableHeaderData={PaymentRegisterTableHeaders}
                    includeCount={true}
                  />
                </section>
              </TabPanel>
              <TabPanel>
                <section className="table-container">
                  <h2
                    style={{
                      marginBottom: "25px",
                    }}
                  >
                    Cleared Payments
                  </h2>
                  <div>
                    <Table<MatchedPaymentRegisterItemWithBankDetails>
                      data={paymentsOutput.clearedPayments}
                      tableHeaderData={ClearedPaymentRegisterTableHeaders}
                      includeCount={true}
                    />
                  </div>
                </section>
              </TabPanel>
            </Tabs>
          </section>
        )}
      </section>
    </section>
  );
}

export { Payments };

function createMatchingPRTableData(
  headers: (PaymentRegisterHeaders | MatchingBSHeadersInPR)[],
  clearedPayments: MatchedPaymentRegisterItemWithBankDetails[]
) {
  const tableHeaders = headers;
  const tableData: (string | number)[][] = clearedPayments.map(
    (matchingEntry: MatchedPaymentRegisterItemWithBankDetails) => {
      return headers.map((headerColumn) => {
        return matchingEntry[headerColumn];
      });
    }
  );
  console.log({ tableData });
}
